import { jsx as _jsx } from "react/jsx-runtime";
/** Themed surface container (bet panel, bet list, history bar). */
export function Panel({ className, ...rest }) {
    return _jsx("div", { className: ["cx-panel", className ?? ""].filter(Boolean).join(" "), ...rest });
}
//# sourceMappingURL=Panel.js.map